import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "team",
  singular: "team member",
  title: "Team",
  subtitle: "Team members and departments.",
  titleKey: "name",
  statusFilter: ["active", "disabled"],
  columns: [
    {
      key: "name",
      label: "Name",
      render: (r) => (
        <div className="flex items-center gap-2">
          {r.avatar ? (
            <img src={typeof r.avatar === "string" ? r.avatar : r.avatar?.src} alt="" className="w-8 h-8 rounded-full object-cover bg-white/10" />
          ) : (
            <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-[10px] text-white/60">
              {(r.initials || r.name || "?").toString().slice(0, 2)}
            </div>
          )}
          <span className="text-white font-medium">{r.name}</span>
        </div>
      ),
    },
    { key: "role", label: "Role" },
    { key: "department", label: "Department" },
    { key: "email", label: "Email" },
    { key: "status", label: "Status", badge: true, className: "w-32" },
  ],
  fields: [
    { key: "name", label: "Name", type: "text" },
    { key: "role", label: "Role", type: "text" },
    { key: "department", label: "Department", type: "text" },
    { key: "email", label: "Email", type: "text" },
    { key: "bio", label: "Bio", type: "textarea" },
    { key: "avatar", label: "Photo", type: "image", folder: "team", hint: "Upload a headshot or pick from the media library" },
    { key: "initials", label: "Avatar Initials", type: "text", hint: "Fallback when no photo is set" },
    { key: "order", label: "Display Order", type: "number" },
    { key: "status", label: "Status", type: "select", options: [
      { label: "Active", value: "active" }, { label: "Disabled", value: "disabled" }
    ]},
  ],
  defaultValues: { status: "active", order: 0, social: {}, avatar: "", initials: "" },
};

export default function Team() { return <GenericCRUD config={config} />; }
